/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertRequestBody,
  UpsertRequestBody$Outbound,
  UpsertRequestBody$outboundSchema,
} from "../components/upsertrequestbody.js";

export type UpsertServerNameOverrideSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpsertServerNameOverrideSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpsertServerNameOverrideSecurity = {
  option1?: UpsertServerNameOverrideSecurityOption1 | undefined;
  option2?: UpsertServerNameOverrideSecurityOption2 | undefined;
};

export type UpsertServerNameOverrideRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  upsertRequestBody: UpsertRequestBody;
};

/** @internal */
export type UpsertServerNameOverrideSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpsertServerNameOverrideSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpsertServerNameOverrideSecurityOption1$Outbound,
    UpsertServerNameOverrideSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function upsertServerNameOverrideSecurityOption1ToJSON(
  upsertServerNameOverrideSecurityOption1:
    UpsertServerNameOverrideSecurityOption1,
): string {
  return JSON.stringify(
    UpsertServerNameOverrideSecurityOption1$outboundSchema.parse(
      upsertServerNameOverrideSecurityOption1,
    ),
  );
}

/** @internal */
export type UpsertServerNameOverrideSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpsertServerNameOverrideSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpsertServerNameOverrideSecurityOption2$Outbound,
    UpsertServerNameOverrideSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function upsertServerNameOverrideSecurityOption2ToJSON(
  upsertServerNameOverrideSecurityOption2:
    UpsertServerNameOverrideSecurityOption2,
): string {
  return JSON.stringify(
    UpsertServerNameOverrideSecurityOption2$outboundSchema.parse(
      upsertServerNameOverrideSecurityOption2,
    ),
  );
}

/** @internal */
export type UpsertServerNameOverrideSecurity$Outbound = {
  Option1?: UpsertServerNameOverrideSecurityOption1$Outbound | undefined;
  Option2?: UpsertServerNameOverrideSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpsertServerNameOverrideSecurity$outboundSchema: z.ZodMiniType<
  UpsertServerNameOverrideSecurity$Outbound,
  UpsertServerNameOverrideSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpsertServerNameOverrideSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpsertServerNameOverrideSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function upsertServerNameOverrideSecurityToJSON(
  upsertServerNameOverrideSecurity: UpsertServerNameOverrideSecurity,
): string {
  return JSON.stringify(
    UpsertServerNameOverrideSecurity$outboundSchema.parse(
      upsertServerNameOverrideSecurity,
    ),
  );
}

/** @internal */
export type UpsertServerNameOverrideRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpsertRequestBody: UpsertRequestBody$Outbound;
};

/** @internal */
export const UpsertServerNameOverrideRequest$outboundSchema: z.ZodMiniType<
  UpsertServerNameOverrideRequest$Outbound,
  UpsertServerNameOverrideRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    upsertRequestBody: UpsertRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      upsertRequestBody: "UpsertRequestBody",
    });
  }),
);

export function upsertServerNameOverrideRequestToJSON(
  upsertServerNameOverrideRequest: UpsertServerNameOverrideRequest,
): string {
  return JSON.stringify(
    UpsertServerNameOverrideRequest$outboundSchema.parse(
      upsertServerNameOverrideRequest,
    ),
  );
}
